import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import client from '../../LikePlusClient'

export default class RechargeAside extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalVisible: false
    }
    this.finishRescue = this.finishRescue.bind(this)
  }

  finishRescue () {
    if (this.props.rechargePoints <= this.props.balance.pointsValue) {
      const payload = this.createPayload()
      console.log(payload)
      client.redemptionCard(payload, this.props.accessToken)
        .then((response) => {
          console.log('response', response)
          this.handleAlert(true, false, 'Sucesso !!!', 'A carga foi realizado com sucesso')
          this.props.handleSuccess(true)
          this.props.handleTransactionId(response.order.liveOrderId)
        }).catch((error) => {
          console.log('error', error)
          // TODO: remover isso, apenas para testar
          this.handleAlert(true, true, 'Oops !!!', 'Houve algum erro ao realizar a carga no seu cartão. Por favor tente novamente.')
          this.props.handleSuccess(false)
        })
    } else {
      this.handleAlert(true, true, 'Oops !!!', 'O valor a ser creditado é maior do que o saldo disponivel, por favor revise a quantidade ou consiga mais saldo')
    }
  }

  createPayload () {
    let cpf = this.props.participant.cpf.value
    let name = this.props.participant.name.value
    let obj = {
      totalMiles: parseFloat(this.props.rechargeCredits),
      totalPoints: parseFloat(this.props.rechargePoints),
      transferKey: 'cpf',
      loyaltyNumber: cpf,
      cpf: cpf,
      participantName: name,
      offline: false,
      orderItems: [],
      orderTypeId: 3
    }

    obj.orderItems.push(this.getPoints())

    return obj
  }

  getPoints () {
    let points = parseFloat(this.props.rechargePoints)
    let miles = parseFloat(this.props.rechargeCredits)
    let obj = {
      quantity: 1,
      points: points,
      miles: miles,
      totalPoints: points,
      packageName: `${points} Pontos Like+`
    }

    return obj
  }

  handleAlert (show, isError, title, message) {
    let alert = {
      show,
      isError,
      title,
      message
    }
    this.props.handleAlert(alert)
  }

  render () {
    return (
      <Fragment>
        <div className='border-color-ui-3 bg-white border px-3 py-4'>
          {this.props.success
            ? (<h3>Sobre sua solicitação</h3>)
            : (<h3>Resumo da solicitação</h3>)
          }
        </div>
        <div className='border-color-ui-3 bg-ui-4 p-0 col-12 border-right border-left'>
          <div className='border-bottom border-color-ui-3 px-3 py-2'>
            <p className='mb-2'><strong>Recarga Cartão Like Mais</strong></p>
            {this.props.success
              ? (
                <Fragment>
                  <p>Realizada em: <strong>06/07/2019 às 14h13</strong></p>
                  <p>Total de pontos utilizados: <strong>{this.props.rechargePoints} pontos</strong></p>
                  <p>Valor em reais creditado: <strong>R$ {this.props.rechargeCredits}</strong></p>
                </Fragment>
              ) : (
                <Fragment>
                  <p>Recarga: <strong>{this.props.rechargePoints} pontos</strong></p>
                  <p>Valor em reais a ser creditado: <strong>R$ {this.props.rechargeCredits}</strong></p>
                </Fragment>
              )}
          </div>
          <div className='px-3 py-2'>
            <p>Solicitante: <strong>{this.props.participant.name.value}</strong></p>
            <p>CPF: <strong>{this.props.participant.cpf.value}</strong></p>
          </div>
        </div>
        <div className='border-color-ui-3 p-0 col-12 bg-white border'>
          {!this.props.success && (
            <div className='d-flex justify-content-between px-3 py-2'>
              <p>Total de pontos utilizados</p>
              <p><strong>{this.props.rechargePoints} ponto</strong></p>
            </div>
          )}
          <div className='px-3 py-2'>
            {this.props.success
              ? (
                <Fragment>
                  <Link className='btn btn-featured btn-icon txt-button txt-font-body mb-2' to='/like-plus' role='button' >
                    <i className='icon icon_donation' aria-hidden='true' /> FAZER UMA DOAÇÃO
                  </Link>
                  <button className='btn btn-featured btn-icon txt-button txt-font-body' >
                    <i className='icon icon_copy' aria-hidden='true' /> IMPRIMIR PEDIDO
                  </button>
                </Fragment>
              ) : (
                <Fragment>
                  <p className='mb-2'>Ao finalizar declaro que li e aceito os <span className='txt-underline color-brand-2-like'>termos do regulamento.</span></p>
                  <a className='btn btn-featured btn-icon txt-button txt-font-body'
                    disabled={this.props.rechargePoints === 0}
                    role='button'
                    onClick={this.finishRescue}>
                    <i className='icon icon_gift' aria-hidden='true' /> FINALIZAR RESGATE
                  </a>
                </Fragment>
              )}
          </div>
        </div>
      </Fragment>
    )
  }
}

RechargeAside.propTypes = {
  success: PropTypes.bool,
  rechargePoints: PropTypes.number,
  rechargeCredits: PropTypes.number,
  participant: PropTypes.object,
  handleSuccess: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object,
  handleAlert: PropTypes.func,
  handleTransactionId: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/Recharge/RechargeAside.js